// extracted by mini-css-extract-plugin
module.exports = {"card":"About_card__hIhOY","heading":"About_heading__sOjWZ","bar":"About_bar__dPILv","description":"About_description__uQMGo","quote":"About_quote__GwzCt"};